/* import __COLOCATED_TEMPLATE__ from './related-conversation-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import type { ConversationExploreConversation } from 'embercom/components/reporting/automation/ai-insights/conversation-panel';
import { action } from '@ember/object';

interface Signature {
  Args: {
    conversation: ConversationExploreConversation;
    onConversationClicked: (conversation: ConversationExploreConversation) => void;
  };
}

interface AvatarDataModel {
  avatarData: {
    avatarShape: 'circle' | 'squircle' | undefined;
    initials: string;
    isCustomer: boolean;
  };
}

export default class RelatedConversationCard extends Component<Signature> {
  get nameToDisplay(): string {
    return this.args.conversation.userName
      ? this.args.conversation.userName
      : this.args.conversation.userPseudonym || '-';
  }

  get avatarModel(): AvatarDataModel {
    let initials = this.args.conversation.userName
      ? this.args.conversation.userName
          .split(' ')
          .map((name: string) => name[0])
          .join('')
          .toUpperCase()
      : '-';
    return {
      avatarData: {
        avatarShape: 'circle',
        initials,
        isCustomer: true,
      },
    };
  }

  get summaryList() {
    return this.args.conversation.topicSummary.split('\n');
  }

  get timeToDisplay() {
    return this.args.conversation.time as string;
  }

  @action
  handleConversationClick() {
    this.args.onConversationClicked(this.args.conversation);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::RelatedConversationCard': typeof RelatedConversationCard;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/related-conversation-card': typeof RelatedConversationCard;
  }
}
